<!-- 线路管理 -->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery1">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('路线名称')">
              <j-input :placeholder="$t('请输入线路名称')" v-model="queryParam.routeName"></j-input>
            </a-form-item>
          </a-col>
          <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('状态')">
              <a-input :placeholder="$t('请输入状态')" v-model="queryParam.routeState"></a-input>
            </a-form-item>
          </a-col> -->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('路线类型')">
              <j-dict-select-tag v-model="queryParam.routeType" :dictCode="'routeType'" :showSearch="false" :placeholder="$t('请选择路线类型')" />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery1" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset1" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('新增') }}</a-button>
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('tickets')">{{ $t('导出') }}</a-button> -->
      <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">{{ $t('导入') }}</a-button>
      </a-upload> -->
      <!-- 高级查询区域 -->
      <!-- <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query> -->
      <!-- <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown> -->
    </div>

    <!-- table区域-begin -->
    <div>
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
      </div> -->

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :customRow="customRow"
        :rowSelection="{type:'radio',selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap "
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text,record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" :preview="record.id" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click.stop="handleEdit(record)">{{ $t('编辑') }}</a>
          <a-divider type="vertical" />
          </a-popconfirm>
          <a-dropdown>
            <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click.stop="handleDetail(record)">{{ $t('详情') }}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('确定删除吗?')" @confirm.stop="() => handleDelete1(record.id)">
                  <a>{{ $t('删除') }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <div style="margin-top: 50px;" v-if="selectedRowKeys.length>0">
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns1"
        :dataSource="dataSource1"
        :loading="loading"
        class="j-table-force-nowrap "
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail1(record)">{{ $t('详情') }}</a>
        </span>
      </a-table>
    </div>

    <lineModal ref="modalForm" @ok="callback"></lineModal>
    <deviceModal ref="deviceForm"></deviceModal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import lineModal from './modules/lineModal'
  import deviceModal from '../deviceManagement/modules/deviceModal'
  import {
    filterDictTextByMany,
    filterDictTextByCache
  } from '@/components/dict/JDictSelectUtil';
  import JInput from '@/components/jeecg/JInput'

  export default {
    name: 'lineList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      lineModal,
      deviceModal,
      JInput
    },
    data () {
      return {
        url: {
          list: "/jeecg-engineering/inspection/inspectionRoute/list",
          delete: "/jeecg-engineering/inspection/inspectionRoute/delete",
          deleteBatch: "/jeecg-engineering/inspection/inspectionRoute/deleteBatch",
          queryById: "/jeecg-engineering/inspection/inspectionRoute/queryById",
        },
        dictOptions:{},
        superFieldList:[],
        dataSource1:[],
        ipagination1: {}
      }
    },
    created() {},
    computed: {
      description() {
        return this.$t('线路管理页面')
      },
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('路线名称'),
            align:"center",
            dataIndex: 'routeName'
          },
          {
            title: this.$t('路线里程数(km)'),
            align:"center",
            dataIndex: 'routeMileage'
          },
          {
            title: this.$t('路线类型'),
            align:"center",
            dataIndex: 'routeType',
            customRender: (text) => {
              return filterDictTextByCache('routeType', text)
            }
          },
          {
            title: this.$t('创建人'),
            align:"center",
            dataIndex: 'createBy'
          },
          {
            title: this.$t('创建时间'),
            align:"center",
            dataIndex: 'createTime'
          },
          {
            title: this.$t('备注'),
            align:"center",
            dataIndex: 'remark'
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            width:150,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
      columns1() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('设备编号'),
            align:"center",
            dataIndex: 'deviceNum',
            ellipsis: true,
          },
          {
            title: this.$t('设备类型'),
            align:"center",
            dataIndex: 'deviceType',
            customRender: (text) => {
              return filterDictTextByCache('deviceType', text)
            },
            ellipsis: true,
          },
          {
            title: this.$t('设备名称'),
            align:"center",
            dataIndex: 'deviceName',
            ellipsis: true,
          },
          {
            title: this.$t('设备经度'),
            align:"center",
            dataIndex: 'detectLongitude',
            ellipsis: true,
          },
          {
            title: this.$t('设备纬度'),
            align:"center",
            dataIndex: 'detectLatitude',
            ellipsis: true,
          },
          {
            title: this.$t('备注'),
            align:"center",
            dataIndex: 'remark',
            ellipsis: true,
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            width:150,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      searchQuery1(){
        this.selectedRowKeys = [];
        this.dataSource1 = [];
        this.searchQuery()
      },
      searchReset1(){
        this.selectedRowKeys = [];
        this.dataSource1 = [];
        this.searchReset()
      },
      handleDelete1(id){
        this.selectedRowKeys = [];
        this.dataSource1 = [];
        this.handleDelete(id)
      },
      // 上面选择
      onSelectChange(selectedRowKeys, selectionRows) {
        this.selectedRowKeys = selectedRowKeys;
        this.selectionRows = selectionRows;
        this.ipagination1 = this.$options.data.call(this).itemIpagination;
        if (this.selectedRowKeys.length == 0) {
          this.dataSource1 = []
          return;
        }
        getAction(this.url.queryById,{id:selectedRowKeys[0]}).then(res=>{
          if(res.success){
            this.dataSource1 = res.result.inspectionTaskRouteDeviceList;
          }
        })
      },
      customRow (record, index) {
        return {
          on:{
            click:(e)=>{
              this.selectedRowKeys = [e.currentTarget.dataset.rowKey];
              getAction(this.url.queryById,{id:e.currentTarget.dataset.rowKey}).then(res=>{
                if(res.success){
                  this.dataSource1 = res.result.inspectionTaskRouteDeviceList;
                }
              })
            }
          }
        }
      },
      handleDetail(record){
        getAction(this.url.queryById, { id: record.id }).then(res => {
          if (res.success) {
            this.$refs.modalForm.edit(res.result);
            this.$refs.modalForm.title = this.$t('详情');
            this.$refs.modalForm.disableSubmit = true;
          }
        });
      },
      handleEdit(record){
        getAction(this.url.queryById, { id: record.id }).then(res => {
          if (res.success) {
            this.$refs.modalForm.edit(res.result);
            this.$refs.modalForm.title = this.$t('编辑');
            this.$refs.modalForm.disableSubmit = false;
          }
        });
      },
      handleDetail1(row){
        this.$refs.deviceForm.edit({...row,id:row.deviceId});
        this.$refs.deviceForm.title = this.$t('详情');
        this.$refs.deviceForm.disableSubmit = true;
      },
      callback(bool){
        this.loadData();
        if(bool){
          getAction(this.url.queryById,{id:this.selectedRowKeys[0]}).then(res=>{
            if(res.success){
              this.dataSource1 = res.result.inspectionTaskRouteDeviceList;
            }
          })
        }else{
          this.selectedRowKeys = [];
          this.dataSource1 = [];
        }
      },
      handleTableChange(pagination, filters, sorter) {
        //分页、排序、筛选变化时触发
        //TODO 筛选
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
        this.ipagination = pagination;
        this.loadData();
        this.selectedRowKeys = [];
        this.dataSource1 = [];
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
  /deep/ .ant-table-thead{
    position: sticky;
    top: 0;
    z-index: 1;
  }
  /deep/ .ant-table-body{
    overflow-y: scroll;
    max-height: 450px;
  }
</style>